import { createContext, useContext } from "react"

export type ConsentStatus = "undecided" | "accepted" | "rejected"

interface CookieConsentContextValue {
  consentStatus: ConsentStatus
  requiresConsent: boolean
  showBanner: boolean
  acceptCookies: () => void
  rejectCookies: () => void
  openBanner: () => void
}

export const CookieConsentContext = createContext<CookieConsentContextValue | null>(null)

export function useOptionalCookieConsent() {
  return useContext(CookieConsentContext)
}

export function useCookieConsent() {
  const context = useOptionalCookieConsent()
  if (!context) {
    throw new Error("useCookieConsent must be used within a CookieConsentProvider")
  }
  return context
}
